import { useEffect } from "react";
import URLService from "../service/urlService";

function RedirectToDepartureOperator() {
  useEffect(() => {
    window.location.href = URLService.generateRedirectUrl(
      window._env_.REACT_APP_DEPARTURE_OPERATOR_URL
    );
  }, []);

  return null;
}

export default RedirectToDepartureOperator;
